import { render, staticRenderFns } from "./Integrations.vue?vue&type=template&id=90fe5aae&"
import script from "./Integrations.vue?vue&type=script&lang=js&"
export * from "./Integrations.vue?vue&type=script&lang=js&"
import style0 from "./Integrations.vue?vue&type=style&index=0&id=90fe5aae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports